import { api, HttpError } from '../api/client.js';
import { store } from '../state/store.js';
import { navigate } from '../router.js';

export function renderLogin(root: HTMLElement): void {
  root.innerHTML = `
    <div class="auth-shell">
      <div class="auth-hero-wrap">
        <img src="/img/hero.jpg" alt="" class="auth-hero" />
      </div>
      <div class="auth-card">
        <img src="/img/ui/title.webp" alt="Rex Mortis" class="auth-logo" />
        <p class="subtitle" style="text-align:center; margin-top: 0;">— Of crowns, bones, and the patient dead —</p>

        <div id="err" class="alert danger" hidden></div>

        <form id="loginForm" autocomplete="on">
          <div class="field">
            <label for="email">Email</label>
            <input id="email" name="email" type="email" required autocomplete="email" />
          </div>
          <div class="field">
            <label for="password">Password</label>
            <input id="password" name="password" type="password" required autocomplete="current-password" />
          </div>
          <button class="btn" type="submit" id="submit">Enter the Realm</button>
        </form>

        <p class="auth-meta">
          New to the realm? <a href="#/register">Forge a character</a>.
        </p>
        <p class="auth-meta" style="margin-top: -4px;">
          Forgotten thy word of passage? <a href="#/forgot-password">Recover by raven</a>.
        </p>
      </div>
    </div>
  `;

  const form = root.querySelector<HTMLFormElement>('#loginForm')!;
  const errBox = root.querySelector<HTMLDivElement>('#err')!;
  const submit = root.querySelector<HTMLButtonElement>('#submit')!;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errBox.hidden = true;
    submit.disabled = true;
    submit.textContent = '…';

    const email = (form.elements.namedItem('email') as HTMLInputElement).value;
    const password = (form.elements.namedItem('password') as HTMLInputElement).value;

    try {
      const res = await api.login({ email, password });
      store.set({
        accessToken: res.accessToken,
        account: res.account,
        character: res.character,
      });
      navigate('/profile');
    } catch (err) {
      const msg = err instanceof HttpError ? err.message : 'Could not sign in.';
      errBox.textContent = msg;
      errBox.hidden = false;
    } finally {
      submit.disabled = false;
      submit.textContent = 'Enter the Realm';
    }
  });
}
